import { MapPin, PawPrint } from "lucide-react";
import logoAsset from "@/assets/petmoon-logo.png.asset.json";

export function Header() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-border/60 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
        <a href="#" className="flex items-center gap-2.5" aria-label="PetMoon — inicio">
          <img
            src={logoAsset.url}
            alt="Logo de PetMoon transporte de mascotas"
            className="h-10 w-10 rounded-full shadow-soft"
            width={40}
            height={40}
          />
          <span className="font-display text-xl font-bold tracking-tight text-primary">
            PetMoon
          </span>
        </a>

        <nav
          className="hidden items-center gap-8 text-sm font-bold text-muted-foreground md:flex"
          aria-label="Navegación principal"
        >
          <a href="#como-funciona" className="transition-colors hover:text-primary">
            Cómo funciona
          </a>
          <a href="#luna" className="transition-colors hover:text-primary">
            Nuestra historia
          </a>
          <a href="#contacto" className="transition-colors hover:text-primary">
            Contacto
          </a>
          <a
            href="/seguimiento"
            className="inline-flex items-center gap-1.5 transition-colors hover:text-primary"
          >
            <MapPin className="h-4 w-4" aria-hidden />
            Seguimiento
          </a>
        </nav>

        <a
          href="#reservar"
          className="inline-flex items-center gap-2 rounded-full bg-accent px-4 py-2.5 text-sm font-extrabold text-accent-foreground shadow-soft transition-transform hover:-translate-y-0.5 sm:px-5"
        >
          <PawPrint className="h-4 w-4" aria-hidden />
          Solicitar Viaje
        </a>
      </div>
    </header>
  );
}
